import React from "react";
import { StarIcon } from "lucide-react";
import { Section } from "./Section";
import { SectionHeading } from "./SectionHeading";
import { testimonials } from "../data/testimonials";
export function TestimonialsSection() {
  return <Section tone="paper" cta={{
    label: "Join them — get my blueprint",
    sub: "$27 USD · One-Time Payment · Instant Digital Access"
  }} data-id="element-296" data-mp="1mziu955eqlmp">
      <SectionHeading eyebrow="What readers are saying" title="Professionals who organized their GI nutrition library" data-id="element-297" data-mp="1d1umnempdjn4" />
      <div className="mx-auto mt-10 grid max-w-5xl gap-5 md:grid-cols-3" data-id="element-298" data-mp="1i1z3j5riwgdv">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-navy-950/5" data-id="element-299" data-mp="142hkz84tlzcy">
            <div className="flex gap-0.5 text-cta" aria-label="5 out of 5 stars" data-id="element-300" data-mp="1831kgicv9f29">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-301" data-mp="32haw6v4jh7dj" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 text-[16px] leading-relaxed text-ink" data-id="element-302" data-mp="2v0j49k95tux5">"{t.quote}"</blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-303" data-mp="2q1gbay6gff5j">
              <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand/20" loading="lazy" data-id="element-304" data-mp="34rx987jvrmxo" />
              <div data-id="element-305" data-mp="2zst2roocc3b1">
                <p className="font-display font-extrabold text-ink" data-id="element-306" data-mp="2zudvd8r3hc69">{t.name}</p>
                <p className="text-[13px] text-muted" data-id="element-307" data-mp="2c38f4sh8shvf">{t.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>
    </Section>;
}